import { Col, Row } from "antd";
import * as React from "react";
import {
  AutoSizer as _AutoSizer,
  AutoSizerProps,
  CellMeasurer as _CellMeasurer,
  CellMeasurerCache,
  ListProps,
  List as _List,
  CellMeasurerProps,
} from "react-virtualized";
import { Status } from "./Status";
const AutoSizer = _AutoSizer as unknown as React.FC<AutoSizerProps>;
const List = _List as unknown as React.FC<ListProps>;
const CellMeasurer = _CellMeasurer as unknown as React.FC<CellMeasurerProps>;
/*
/* FIXME: working example of WindowScroller 
/* https://jsfiddle.net/6md5st9h/209/ 
*/

interface MobileListProps {
  data: API_Question[];
  goToQuestion: (id: number) => void;
}

const cache = new CellMeasurerCache({
  defaultHeight: 50,
  fixedWidth: true,
  // keyMapper: () => 1
});

export class MobileList extends React.Component<MobileListProps> {
  componentDidUpdate() {
    cache.clearAll();
  }

  rowRenderer = ({ index, key, style, parent }) => {
    const { data, goToQuestion } = this.props;
    const { id, topic, status } = data[index];

    return (
      <CellMeasurer cache={cache} parent={parent} columnIndex={0} rowIndex={index} key={key}>
        <Row style={style} className="qa-list-row" onClick={() => goToQuestion(id)}>
          <Col span={24} className="qa-title mb-2">
            #{id}: {topic}
          </Col>
          <Col span={24} className="mb-2" style={{ height: "20px" }}>
            <Status type={status} />
          </Col>
        </Row>
      </CellMeasurer>
    );
  };

  render() {
    const { data } = this.props;
    return (
      <div className="flex flex-with-basis qa-list qa-mobile-list">
        <AutoSizer>
          {({ width, height }) => (
            <List
              width={width}
              height={height}
              rowHeight={cache.rowHeight}
              rowCount={data.length}
              rowRenderer={this.rowRenderer}
              deferredMeasurementCache={cache}
            />
          )}
        </AutoSizer>
      </div>
    );
  }
}
